// Generated by ts-to-zod
import { z } from 'zod';

export const genericEngineListQuerySchema = z.object({
  pageSize: z.number().optional(),
  page: z.number().optional(),
  fields: z
    .array(
      z.union([
        z.literal('id'),
        z.literal('name'),
        z.literal('url'),
        z.literal('schema'),
        z.literal('description'),
        z.literal('documentationUrl'),
      ])
    )
    .optional(),
  ordering: z
    .array(
      z.union([
        z.literal('id'),
        z.literal('name'),
        z.literal('url'),
        z.literal('schema'),
        z.literal('description'),
        z.literal('documentationUrl'),
        z.literal('-id'),
        z.literal('-name'),
        z.literal('-url'),
        z.literal('-schema'),
        z.literal('-description'),
        z.literal('-documentationUrl'),
      ])
    )
    .optional(),
  id: z.union([z.number(), z.array(z.number())]).optional(),
  name: z.union([z.number(), z.array(z.number())]).optional(),
  url: z.union([z.number(), z.array(z.number())]).optional(),
  schema: z.union([z.number(), z.array(z.number())]).optional(),
  description: z.union([z.number(), z.array(z.number())]).optional(),
  documentationUrl: z.union([z.number(), z.array(z.number())]).optional(),
});
